// Peças que as duas páginas com dados da DRE repartem (aviso com link, tooltip do gráfico,
// estado de carregando/erro/sem acesso). Sem regra de negócio: as contas ficam em dadosSetores.ts.
import type { ReactNode } from 'react';
import { Alert, Button, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { metaSetor } from '../../../utils/setoresDre';
import { reais } from './dadosSetores';

export const LINK_AREAS = '/operacional/contratos?vista=areas';
export const LINK_LANCAMENTOS = '/financeiro/dre-hub?aba=lancamentos';
export const LINK_MAO_OBRA = '/financeiro/dre-hub?aba=mao-obra';

/** Link interno com texto de menu ("Operacional › Contratos › Áreas e CNAE"). */
export function IrPara({ para, children }: { para: string; children: ReactNode }) {
  return <Link to={para}>{children}</Link>;
}

export function SemAcesso({ texto }: { texto?: string }) {
  return (
    <Alert
      type="warning" showIcon
      message="Você não tem acesso a esta página"
      description={texto || 'Os números desta página são do financeiro. Peça acesso ao Lucas se precisar deles.'}
    />
  );
}

/** Quando a lista de acessos não carregou (rede): não é o mesmo que "sem acesso". */
export function AcessoNaoConferido({ onTentar }: { onTentar: () => void }) {
  return (
    <Alert
      type="warning" showIcon
      message="Não consegui conferir o seu acesso"
      description="Foi um problema de conexão, não falta de permissão. Tente de novo em instantes."
      action={<Button size="small" onClick={onTentar}>Tentar de novo</Button>}
    />
  );
}

export function Carregando({ texto }: { texto?: string }) {
  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <Spin size="large" />
      {texto ? <div style={{ marginTop: 12, color: '#8c8c8c' }}>{texto}</div> : null}
    </div>
  );
}

/** Tooltip de gráfico empilhado: uma linha por setor (só os que têm valor) e o total da barra. */
export function TooltipEmpilhado({ active, payload, label, rotuloTotal }: {
  active?: boolean; payload?: any[]; label?: string; rotuloTotal: string;
}) {
  if (!active || !payload || !payload.length) return null;
  const linha = payload[0]?.payload || {};
  const itens = payload
    .filter((p) => p.dataKey !== 'total' && Math.abs(Number(p.value) || 0) >= 0.5)
    .sort((a, b) => (Number(b.value) || 0) - (Number(a.value) || 0));
  return (
    <div style={{ background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 12px', fontSize: 12, boxShadow: '0 2px 8px rgba(0,0,0,.12)' }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{label}{linha.parcial ? ' (mês em andamento)' : ''}</div>
      {itens.map((p) => (
        <div key={String(p.dataKey)} style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}>
          <span><span style={{ display: 'inline-block', width: 10, height: 10, background: p.color || p.fill, marginRight: 6, borderRadius: 2 }} />{metaSetor(String(p.dataKey)).rotulo}</span>
          <span style={{ color: Number(p.value) < 0 ? '#a8071a' : undefined }}>{reais(Number(p.value))}</span>
        </div>
      ))}
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, borderTop: '1px solid #f0f0f0', marginTop: 4, paddingTop: 4, fontWeight: 600 }}>
        <span>{rotuloTotal}</span><span>{reais(Number(linha.total) || 0)}</span>
      </div>
    </div>
  );
}

/** Bolinha colorida do setor + rótulo (legenda das tabelas, com a mesma cor do gráfico). */
export function EtiquetaSetor({ chave }: { chave: string }) {
  const m = metaSetor(chave);
  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <span style={{ display: 'inline-block', width: 10, height: 10, background: m.cor, marginRight: 6, borderRadius: 2, border: m.chave === 'sem_setor' ? '1px solid #bfbfbf' : undefined }} />
      {m.rotulo}
    </span>
  );
}
